<template>
  <div class="wrap">
    <div style="height:180px"></div>
    <div class="loginwrap">
      <div class="imgcons">
        <img :src="imgsrc" style="height:323px">
      </div>
      <el-form :model="loginForm" :rules="fieldRules" ref="loginForm" label-position="left" label-width="0px"
        class="demo-ruleForm login-container">
        <span class="tool-bar">
          <!-- 主题切换 -->

          <!-- 语言切换 -->
          <!-- <lang-selector class="lang-selector"></lang-selector>    -->
        </span>
        <!-- <h1 class="title" style="padding-left:22px;" ><img src="../assets/selogo.png" alt=""> 看看民政</h1> -->
        <div class="incon">{{ title }}</div>

        <input type="text" v-model="loginForm.account" class="acc" auto-complete="off" placeholder="账号">



        <input type="password" v-model="loginForm.password" class="pass" auto-complete="off" placeholder="密码">
        <div class="codeCon">
          <input type="text" v-model="loginForm.captcha" class="code" auto-complete="off" placeholder="请输入验证码">
          <img class="pointer" :src="loginForm.src" @click="refreshCaptcha">
        </div>
        <div class="cccc">
          <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox>


          <el-button class="dl" style="width:48%;" @click.native.prevent="login" :loading="loading">立即登录</el-button>
        </div>
      </el-form>
    </div>
    <p class="suppots">Power By:上海看看智能有限公司</p>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Cookies from "js-cookie"
import ThemePicker from "@/components/ThemePicker"
import LangSelector from "@/components/LangSelector"
import { config } from "@/utils/config/urlConfig"
export default {
  name: 'Login',
  components: {
    ThemePicker,
    LangSelector
  },
  data() {
    return {
      imgsrc: config.homeBackground,
      title: config.homeTitle,
      loading: false,
      loginForm: {
        account: '',
        password: '',
        captcha: '',
        src: ''
      },
      fieldRules: {
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
        // ,
        // captcha: [
        //   { required: true, message: '请输入验证码', trigger: 'blur' }
        // ]
      },
      checked: true
    }
  },
  methods: {
    login() {
      this.loading = true
      let userInfo = { account: this.loginForm.account, password: this.loginForm.password, captcha: this.loginForm.captcha }
      this.$api.login.login(userInfo).then((res) => {
        if (res.code != 200) {
          this.$message({
            message: res.message,
            type: 'error'
          })
        } else {
          console.log(res.data, 'res.data')
          Cookies.set('token', res.data.token) // 放置token到Cookie
          sessionStorage.setItem('user', userInfo.account) // 保存用户到本地会话
          sessionStorage.setItem("typeControll", res.data.typeControll)
          sessionStorage.setItem("deptId", res.data.deptId)
          sessionStorage.setItem("codes", JSON.stringify(res.data.dics.verifyDic.codes))
          sessionStorage.setItem("codesvalues", JSON.stringify(res.data.dics.verifyDic.values))
          const roleIds = Array.isArray(res.data.roleIds) ? res.data.roleIds : [res.data.roleIds];
          sessionStorage.setItem("roleIds", JSON.stringify(roleIds));
          let list = {
            province: res.data.province, city: res.data.city, country: res.data.country, town: res.data.town, village: res.data.village,
          }
          sessionStorage.setItem("list", JSON.stringify(list))
          this.$store.commit('menuRouteLoaded', false) // 要求重新加载导航菜单
          if (this.checked) {
            localStorage.setItem("userName", this.loginForm.account)
            localStorage.setItem("password", this.loginForm.password)
          } else {
            localStorage.removeItem("userName")
            localStorage.removeItem("password")
          }
          this.$router.push('/')  // 登录成功，跳转到主页
        }
        this.loading = false
      }).catch((res) => {
        this.$message({
          message: res.message,
          type: 'error'
        })
      });
    },
    refreshCaptcha: function () {
      this.loginForm.src = this.global.baseUrl + "/captcha.jpg?t=" + new Date().getTime();

    },
    reset() {
      this.$refs.loginForm.resetFields()
    },
    // 切换主题
    onThemeChange: function (themeColor) {
      this.$store.commit('setThemeColor', themeColor)
    }
  },
  mounted() {
    var Url = window.location.href
    console.log(Url)
    if (Url.indexOf("manager.minzhengju.com") != -1) {
      if (Url.indexOf("https") == -1) {
        let url = Url.replace("http", "https")
        console.log(url)
        window.location.href = url
      }
    }
    Cookies.remove('token')
    this.$store.state.tab.mainTabs = []
    this.refreshCaptcha()
    if (localStorage.getItem("userName")) {
      this.loginForm.account = localStorage.getItem("userName")
      this.loginForm.password = localStorage.getItem("password")
    }
  },
  computed: {
    ...mapState({
      themeColor: state => state.app.themeColor
    })
  }
}
</script>

<style lang="scss" scoped>
.wrap {

  // background: #505458;
  background: url(../assets/bj.png) no-repeat;
  background-size: 100% 100%;
  height: 100%;
}

.iggf {
  height: 100%;
  position: relative;
}

.igg {
  height: 100%
}

h1 {
  text-align: right;
  font-size: 30px
}

.suppots {
  text-align: center;
  color: #ffffff;
  font-size: 14px;
  margin-top: 100px
}

.loginwrap {
  border: 1px solid lightgray;
  margin: 0 auto;
  border-radius: 10px;
  width: 1000px;
  height: 500px;
  display: flex;
  align-items: center;
  overflow: hidden;
  background: #fff;

  .imgcons {
    float: left;
    margin-left: 10px
  }
}

.login-container {
  float: right;
  width: 450px;
  padding: 5px 35px 15px 35px;

  // border: 1px solid #eaeaea;
  // box-shadow: 0 0 25px #cac6c6;
  .title {
    height: 60px;
    display: flex;
    justify-content: flex-end;

    align-items: center;
    color: #505458;
  }

  .title img {
    height: 100%;
    margin-right: 40px;
  }

}

input {
  outline: none;
  background: none
}

.acc {
  width: 440px;
  border: none;
  height: 45px;
  padding-left: 10px;
  border: 1px solid lightgray
}

.pass,
.code {
  width: 440px;
  padding-left: 10px;
  border: none;
  height: 45px;
  margin-top: 10px;
  border: 1px solid lightgray
}

.code {
  margin-top: 0
}

.codeCon {
  width: 450px;
  position: relative;
  margin-top: 10px;

  .pointer {
    position: absolute;
    height: 80%;
    top: 10%;
    right: 10px;
  }
}

.cccc {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px
}

.dl {
  border-radius: 5px;
  border: none;
  height: 45px;
  color: #ffffff;
  background: #2A81EB;

}

.incon {
  height: 50px;
  display: flex;
  font-size: 25px;
  margin-bottom: 30px;
  justify-content: center;
  align-items: center;

  img {
    height: 100%;
    margin-right: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Login.vue